export const GENDER_LIST = [
	{
		title: 'Männlich',
		value: 'Male'
	},
	{
		title: 'Weiblich',
		value: 'Female'
	},
	{
		title: 'Divers/Non-binary',
		value: 'Diverse'
	}
]

export const CHAT_POLL_TIME = 60000

export const CHAT_SEEN_DELAY = 1000

export const ValidationRegex: Record<string, RegExp> = {
	characters: /[!+/@#$%^&*(),.?±~`":{}|<>]+/,
	lowercase: /[a-z]+/,
	uppercase: /[A-Z]+/,
	numeric: /[0-9]+/
}
